module.exports = __webpack_public_path__ + "static/media/youtubePic.1661e818.png";